export default {
  banner: {
    image: "/img/FordLogo.png",
    title: "Ford x Lasso",
  },
  languageSwitcher: {
    title: "Changer de langue",
    cta: "Changer de langue",
  },
  rulesAndRegs: "Règlements officiels du concours",
  close: "Fermer",
  wait: "Veuillez patienter...",
  email: "Courriel",
  yes: "Oui",
  no: "Non",
  submit: "Participer",
  reset: "Réinitialiser",
  form: {
    title: "Enregistrement",
    subittle: "Remplir le formulaire pour participer au concours",
    rules: "Règlements du concours",
  },
  success: {
    title: "Merci!",
    message: "Votre inscription a été<br/> envoyée avec succès.",
  },
  notFound: {
    title: "Page non trouvée",
    message: "La page que vous cherchez n'existe pas.",
    goHome: "Retour à l'accueil",
  },
  resetTimer: "Réinitialiser {seconds}",
  footer: {
    title: "Règlements officiels du concours",
    credits: "© Ford Canada. Tous droits réservés.",
  },
  error: "Quelque chose s'est mal passé...",
  clearCache: "Effacer la cache du navigateur",
};
